export default __webpack_public_path__ + "static/media/notes-crm.5b52b3aa.svg";